import {E_REPORTING_PAYMENT_TYPE_LABELS, formatDateTime, formatEuro, formatRate} from "@/invoice-transmission/eReportingUtils";

// Déclaration des paiements reçus ("Encaissée") : état de chaque paiement, tel que renvoyé par ms-invoice-transmission.
// À transmettre / en cours / non requis = bleu (information), transmis = vert, erreur = rouge, bloqué = orange.
export const PAYMENT_STATUS = {
    to_send: {label: "À transmettre", color: "#1F3A63", backgroundColor: "#E4EEFC", borderColor: "#E4EEFC"},
    pending: {label: "En cours", color: "#1F3A63", backgroundColor: "#E4EEFC", borderColor: "#E4EEFC"},
    sent: {label: "Transmis", color: "#1b5e20", backgroundColor: "#d7efdc", borderColor: "#d7efdc"},
    error: {label: "Erreur", color: "#a61b1b", backgroundColor: "#fde0e0", borderColor: "#fde0e0"},
    not_required: {label: "Non requis", color: "#1F3A63", backgroundColor: "#ffffff", borderColor: "#b9d3f5"},
    blocked: {label: "Bloqué", color: "#a85a00", backgroundColor: "#fff0d6", borderColor: "#fff0d6"}
};

export function paymentStatusLabel(status) {
    return (PAYMENT_STATUS[status] || {label: status}).label;
}

export function paymentStatusStyle(status) {
    const info = PAYMENT_STATUS[status] || PAYMENT_STATUS.to_send;
    return {color: info.color, backgroundColor: info.backgroundColor, border: `1px solid ${info.borderColor}`};
}

export function paymentTypeLabel(paymentType) {
    return E_REPORTING_PAYMENT_TYPE_LABELS[paymentType] || "";
}

// "60,00 € à 20 % · 55,00 € à 10 %" : ce qui est transmis, par taux de TVA
export function vatBreakdown(payment) {
    return (payment.vatLines || []).map(line => `${formatEuro(line.grossAmount)} à ${formatRate(line.taxPercent)}`).join(" · ");
}

export {formatDateTime};

// Infobulle du bouton "Paiements" d'une ligne du tableau
export function paymentsSummaryTitle(business) {
    const counters = business.paymentTransmission || {sent: 0, error: 0, pending: 0};
    const parts = [`${counters.sent} sur ${Math.max(business.paymentCount || 0, counters.sent)} transmis`];
    if (counters.error) parts.push(`${counters.error} en erreur`);
    if (counters.pending) parts.push(`${counters.pending} en cours`);
    return `Paiements reçus : ${parts.join(", ")}`;
}
